const style = `
  html,
  body {
    height:100%;
    position: relative;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    vertical-align: baseline;
  }
  textarea{outline:none;}
  /*==========공통==========*/
    .jw-state-idle .jw-controls {
      background: rgba(0, 0, 0, 0) !important;
    }
    body {
      font-size: 15px;
      font-family: "Noto Sans KR",'Apple SD Gothic Neo', sans-serif;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
    }
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: 300ms opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-container-horizontal
      > .swiper-pagination-bullets
      .swiper-pagination-bullet {
      margin: 0 4px;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 50%;
      background: #000;
      opacity: 0.2;
    }
    .wid_1240 {
      max-width: 1240px;
      margin: 0 auto;
    }
    .wid_1280 {
      max-width: 1280px;
      margin: 0 auto;
    }
    .wid_1180 {
      max-width: 1180px;
      margin: 0 auto;
    }
    .wid_1060{
      max-width:1060px;
      margin:0 auto;
      padding-bottom:100px;
    }
    .clear:after {
      content: "";
      display: block;
      clear: both;
    }
  /*공통 pc*/
    .content-area {
      height:100%;
      box-sizing: border-box;
      margin-bottom:60px;
    }
    #root {height: 100%;}
    .onair_btn {
      position: relative;
      display: inline-block;
      width: 70px;
      height: 24px;
      border-radius: 12px;
      box-sizing: border-box;
      border: 1px solid #ea3131;
      background: #ea3131;
      text-align: center;
      line-height: initial;
    }
    
    .onair_btn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
      color: #fff;
      font-weight: 400;
    }
    
    .livebtn {
      position: relative;
      display: inline-block;
      width: 57px;
      height: 24px;
      text-align: center;
      background: #fff;
      border: 1px solid #723ec6;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right: 6px;
    }
    .livebtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #723ec6;
      font-size: 12px;
      font-weight: 400;
    }
    .ondemandbtn {
      position: relative;
      display: inline-block;
      width: 96px;
      height: 24px;
      text-align: center;
      background: #fff;
      border: 1px solid #94ad51;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right:6px;
    }
    .ondemandbtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #94ad51;
      font-size: 12px;
      font-weight: 400;
    }
    
    .basic_btn {
      display: inline-block;
      width: 160px;
      height: 48px;
      line-height: 48px;
      background: #6a6af8;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      text-align: center;
    }
    .basic_btn:hover {color: #fff;}

    /*======공통 모바일======*/
    @media (max-width: 767px) {
      .event_area .livebtn {margin-top: 0;}
      .event_area .ondemandbtn{margin-top: 0;}
    }
    /*==========데이터 없을때, 로딩이미지==========*/
    .loading_img {
      background: #111;
      top: 0;
      left: 0;
    }
    .nonedata_box {
      margin: 100px 0;
      text-align: center;
    }
    .nonedata_box p {
      margin-top: 20px;
      font-weight: bold;
      color: #333333;
      font-size: 16px;
    }
    
    
`

export default style